module.exports = __webpack_public_path__ + "img/trees-left.c2f5bfd8.png";